import { useQuery } from "@tanstack/react-query";
import { clientSupplierApi } from "./axios";
import {
    DataI,
    PropsI,
    ServiceResponseI,
    ClientSupplierI,
    OneSupplierI,
} from '../../interfaces';
import {
    ValidateCurrentToken,
    LogoutSystem,
} from '../../helpers'
import { AxiosError } from 'axios';

const getAllClientSupplier = async ({
    pagination,
    sorting,
    globalFilter
}: PropsI): Promise<ServiceResponseI<DataI<ClientSupplierI>>> => {

    try {

        const validateToken = ValidateCurrentToken();

        if (!validateToken) throw new Error('TOKEN INVALIDO');

        const params = new URLSearchParams();

        params.append('page', (pagination!.pageIndex + 1).toString());
        params.append('limit', pagination!.pageSize.toString());
        globalFilter && params.append('search', globalFilter);
        sorting && params.append('sorting', JSON.stringify(sorting));

        //headers: { 'Authorization': validateToken
        const { data } = await clientSupplierApi.get<ServiceResponseI<DataI<ClientSupplierI>>>('', { params, headers: { 'Authorization': validateToken } });
        return data;

    } catch (err) {
        const obj = (err as AxiosError).response;

        if (obj?.status === 401) {
            
            LogoutSystem();
        }

        throw new Error((err as Error).message)
    }


}

// export const getAllSuppliersbyClientId = async (id:number): Promise<ServiceResponseI<OneSupplierI[]>> => {

//     try {
//         const validateToken = ValidateCurrentToken();
//         if (!validateToken) throw new Error('TOKEN INVALIDO');

//         const { data } = await clientSupplierApi.get<ServiceResponseI<OneSupplierI[]>>(`/all-suppliers-by-client-id/${id}`, { headers: { 'Authorization': validateToken } });

//         return data

//     } catch (err) {
//         const obj = (err as AxiosError).response;
//         if (obj?.status === 401) {
//             
//             LogoutSystem();
//         }
//         throw new Error((obj?.data as Error).message)
//     }
// }


export const clientSupplierPost = async<T>(getForms: T): Promise<ServiceResponseI<string>> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await clientSupplierApi.post<ServiceResponseI<string>>("", getForms, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const clientSupplierPut = async<T>(id: number, updateForms: T): Promise<ServiceResponseI<string>> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await clientSupplierApi.put<ServiceResponseI<string>>(`/${id}`, updateForms, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const clientSupplierDelete = async (id: number): Promise<string> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await clientSupplierApi.delete(`/${id}`, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const clientSupplierById = async (id: number): Promise<ServiceResponseI<ClientSupplierI>> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await clientSupplierApi.get<ServiceResponseI<ClientSupplierI>>(`/${id}`, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const useClientSupplier = ({
    sorting,
    pagination,
    globalFilter,
}: PropsI) => {


    const clientSupplierQuery = useQuery(
        ["clientSupplier", { pagination, sorting, globalFilter }],
        () => getAllClientSupplier({ pagination, sorting, globalFilter }),
        {
            refetchOnWindowFocus: false,
            keepPreviousData: true
        }
    );






    return {
        clientSupplierQuery,
    };
}